var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.9977C21 33.1061 22.7092 34.8153 24.8176 34.8153H28.3625C30.6215 34.8153 32.4528 32.9841 32.4528 30.725C32.4528 28.466 30.6215 26.6348 28.3625 26.6348H25.0903C22.8313 26.6348 21 24.8035 21 22.5445C21 20.2855 22.8313 18.4542 25.0903 18.4542H28.6352C30.7436 18.4542 32.4528 20.1634 32.4528 22.2718M26.7264 16V18.4542M26.7264 34.8153V37.2695",
    stroke: "#00AFF0",
    strokeWidth: 3.72813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.36 12.92C38.32 12.92 34.8 7.64 33.92 5C28.64 9.928 22.6267 7.05333 20.28 5C17.112 12.04 11.04 13.2133 8.4 12.92C9.104 20.312 5.76 25.3867 4 27C8.928 31.576 8.69333 38 7.96 40.64C15 40.64 18.52 46.2133 19.4 49C25.032 44.776 31.4267 47.24 33.92 49C34.976 43.368 42.28 41.08 45.8 40.64C42.984 33.248 47.8533 28.4667 50.64 27C44.656 23.48 44.6267 16.1467 45.36 12.92Z",
    stroke: "#00AFF0",
    strokeWidth: 4.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipNotification);
export default __webpack_public_path__ + "static/media/TipNotification.774971d537ee85dbf84fd46ae9902a32.svg";
export { ForwardRef as ReactComponent };